import styled from 'styled-components';

export const Wrapper = styled.div`
    padding: 0 20px 20px 20px;
    width: 100%;
    margin: 0 auto;

    @media screen and (max-width: 769px) {
        max-width: 100%;
    }
`;

export const Hr = styled.div`
    width: 100%;
    height: 0px;
    border: 1px solid #e7e7f0;
    margin-bottom: 20px;
    transform: translateX(-20px);
`;

export const Header = styled.header`
    display: flex;
    align-items: center;
    margin-bottom: 8px;
`;

export const HeaderTextWrapper = styled.div`
    margin-left: 8px;
`;

export const HeaderText = styled.h3`
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin: 0;
`;

export const MainCard = styled.div`
    background: white;
    border-radius: 12px;
    padding: 24px;
    margin-top: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    display: inline-flex;
    gap: 24px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    width: 100%;

    /* Mobile */
    @media (max-width: 768px) {
        padding: 12px;
        gap: 12px;
    }

    @media (max-width: 480px) {
        padding: 8px;
    }
`;
